import { isEmpty, isNil } from 'lodash/fp';
import { nanoid } from 'nanoid';
import { quoteIfNeeded, quoted } from 'app/lib/utils/sql';

export const extractSchema = (view, schema) =>
    `${quoteIfNeeded(view.name)} (${schema
        .map((column) => `${quoted(column.name)} ${column.typeFamily}`)
        .join(', ')})`;

export const parseMessageJson = (response) => {
    const content = response.choices[0].message.content;

    return JSON.parse(content);
};

export const parseStarters = (response) => parseMessageJson(response).queries;

export const BlockType = {
    SQL: 'sql',
    TEXT: 'text'
};

export const Role = {
    SYSTEM: 'system',
    USER: 'user',
    ASSISTANT: 'assistant'
};

export const hasError = (response) => Boolean(response.error);

export const parseBlocks = (response) => {
    const json = parseMessageJson(response);
    const blocks = [];

    if (!isEmpty(json?.sql)) {
        blocks.push({ type: BlockType.SQL, content: json.sql, uuid: nanoid() });
    }

    if (!isEmpty(json?.description)) {
        blocks.push({ type: BlockType.TEXT, content: json.description, uuid: nanoid() });
    }

    return blocks;
};

export const findMessageBlock = (conversation, uuid) => {
    for (const message of conversation.messages) {
        if (isNil(message.blocks)) {
            continue;
        }

        for (const block of message.blocks) {
            if (block.uuid === uuid) {
                return block;
            }
        }
    }
};

const MAX_MESSAGES = 4;

export const truncateMessages = (messages) =>
    messages.filter((_, i) => i === 0 || i >= messages.length - MAX_MESSAGES);
